import { Link } from 'react-router-dom';
import clsx from 'clsx';

export interface WordmarkProps {
  size?: 'sm' | 'md';
  asStatic?: boolean;
  className?: string;
}

/**
 * Shared wordmark logo — "THE ZACHARY GROUP" in Space Grotesk bold, tight-tracked.
 * Used by Navbar (size="sm") and Footer (size="md").
 */
export function Wordmark({ size = 'sm', asStatic = false, className }: WordmarkProps) {
  const fontSize = size === 'md' ? '16px' : '13px';
  const spanClass = clsx(
    'font-display font-bold tracking-[-0.04em] uppercase text-ink',
    className,
  );
  const label = 'THE ZACHARY GROUP';

  if (asStatic) {
    return (
      <span className={spanClass} style={{ fontSize }} aria-label="The Zachary Group">
        {label}
      </span>
    );
  }

  return (
    <Link to="/" aria-label="The Zachary Group — home" className="inline-flex items-center">
      <span className={spanClass} style={{ fontSize }}>
        {label}
      </span>
    </Link>
  );
}
